/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Claude_Web_OpenInputs */

const en_mcp_claude_web_open = /** @type {(inputs: Mcp_Claude_Web_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Claude, go to Customize, then Connectors.`)
};

const es_mcp_claude_web_open = /** @type {(inputs: Mcp_Claude_Web_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Claude, ve a Customize y luego a Connectors.`)
};

/**
* | output |
* | --- |
* | "In Claude, go to Customize, then Connectors." |
*
* @param {Mcp_Claude_Web_OpenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_claude_web_open = /** @type {((inputs?: Mcp_Claude_Web_OpenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Claude_Web_OpenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_claude_web_open(inputs)
	return en_mcp_claude_web_open(inputs)
});